import React, { PropTypes, Component } from 'react';
import classNames from 'classnames'
import BaseDetails from './BaseDetails.jsx';
import { history } from '../../../entry/history';
import { routes } from 'pluton-core/lib/constants/routes.constant';
import { isImportantAlert } from 'pluton-core/lib/services/core/alerts/alerts.helper';


class DetailsLinks extends BaseDetails {

    handleOnGoToAlert = (dateGroupedItem, groupedItem, dateGroupedItemIndex) => {
        history.push(routes.alert());
        this.props.handleSetAlertToJump(dateGroupedItem, groupedItem, dateGroupedItemIndex);
    };

    renderBody = (dateGroupedItem) => {
        const { groupedItems } = dateGroupedItem;
        if (!groupedItems || !groupedItems.length) {
            return null;
        }

        return dateGroupedItem.groupedItems.map((groupedItem, groupedItemIndex) => {
            const isOpen = false;
            const alertClassName = isOpen ? 'alert alert--open' : 'alert alert--home';
            const classNamesObj = classNames({
                [alertClassName]: true,
                'alert--important': isImportantAlert(groupedItem.severity)
            });

            return (
                <div key={groupedItemIndex}
                     className={classNamesObj}
                     onClick={this.handleOnGoToAlert.bind(this, dateGroupedItem, groupedItem, groupedItemIndex)}>
                    <div className="alert__header">
                        {this.renderIcon(groupedItem)}
                        <div className="alert__title">
                            <div className="alert__title-text">
                                {groupedItem.name}
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    };
}

DetailsLinks.propTypes = {
    alertModel: PropTypes.func,
    date: PropTypes.object,
    showImportant: PropTypes.bool,

    details: PropTypes.object,
    handleGetPrev: PropTypes.func,
    handleGetNext: PropTypes.func,

    handleSetAlertToJump: PropTypes.func,
};

export default DetailsLinks;



// WEBPACK FOOTER //
// ./app/components/custom/details/DetailsLinks.jsx